import React from 'react';
import { PxSpacingInput } from '../../../puck/fields/puckPxSpacingField';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';

/**
 * Champ « Marge verticale » — un seul réglage pour `paddingTop` et
 * `paddingBottom` : personne ne veut d'un bandeau qui respire en haut et pas en
 * bas, et les deux props existaient jusqu'ici sans aucun champ pour les régler.
 *
 * Ancré sur `paddingTop`, mais les deux props partent dans le MÊME dispatch :
 * le `onChange` du champ et un dispatch frère se seraient écrasés l'un l'autre,
 * chacun repartant du même instantané de props.
 */
export default function SectionPaddingYField({ value }) {
  const { updateItemProps } = useSelectedItemProps();

  return (
    <PxSpacingInput
      value={value}
      onChange={(next) => updateItemProps({ paddingTop: next, paddingBottom: next })}
      label="Marge verticale"
      description="Espace au-dessus et en dessous du contenu du bloc."
    />
  );
}
